import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import {
  MatDatepickerModule, MatNativeDateModule, MatButtonModule, MatFormFieldModule, MatInputModule, MatSelectModule,
  MatToolbarModule, MatCheckboxModule, MatCardModule, MatGridListModule, MatSidenavModule, MatIconModule, MatTooltipModule,
  MatAutocompleteModule, MatSortModule, MatProgressSpinnerModule, MatChipsModule, MatPaginatorModule
} from '@angular/material';

import {
  MatDialogModule, MatTableModule
} from '@angular/material';

import { MatListModule } from '@angular/material/list';

import { ReactiveFormsModule } from '@angular/forms';
import { BidiModule } from '@angular/cdk/bidi';
import { MessageToUserDialog } from './dialog/messageToUser.dialog';
import { TranslationService } from './services/transalationService';
import { TranslatePipe } from './pipes/translationPipe';
import { versionUpdatesVerifierService } from './services/versionUpdatesVerifier.service';

@NgModule({

  //components, directives and pipes, that are declared and used inside this module.
  declarations: [
    MessageToUserDialog,
    TranslatePipe,
   
  ],
  //angular modules, app Module
  imports: [
    
    RouterModule,
    HttpClientModule,
    FormsModule,

    MatButtonModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatDatepickerModule,
    MatNativeDateModule, MatDialogModule,
  
    MatTableModule,
    MatListModule,
    MatToolbarModule,
    MatCheckboxModule,
    MatCardModule,
    MatGridListModule,
    BidiModule,
    MatIconModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatSortModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatSidenavModule,
    MatChipsModule,
    MatPaginatorModule

    
  ],
  // someServices, dialogs
  providers: [MessageToUserDialog, TranslationService, versionUpdatesVerifierService],

  exports: [
   
    RouterModule,
    HttpClientModule,
    FormsModule,

    MatButtonModule, MatFormFieldModule, MatInputModule, MatSelectModule,  MatDatepickerModule,
    MatNativeDateModule, MatDialogModule,
    MatProgressSpinnerModule,

    MatTableModule,
    MatListModule,
    MatToolbarModule,
    MatCheckboxModule,
    MatCardModule,
    MatGridListModule,
    BidiModule,
    MatSidenavModule,
    MatIconModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatSortModule,
    MatChipsModule,
    ReactiveFormsModule,
    MatPaginatorModule,

    TranslatePipe,
   

  ],
  entryComponents: [MessageToUserDialog],
})
export class SharedModule { }

